import React, { useEffect } from 'react';

const initializeLocalStorageWithObject = (data: Record<string, string>) => {
  Object.entries(data).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

const SsoLogin = () => {
  React.useEffect(() => {
    const queryParam = new URLSearchParams(window.location.search);
    if (queryParam.get('data')) {
      initializeLocalStorageWithObject(JSON.parse(queryParam.get('data')));
      const redirectPath = localStorage.getItem('redirect-path')
        ? localStorage.getItem('redirect-path')
        : '/';
      localStorage.removeItem('redirect-path');
      window.location.href = `${window.location.origin}${redirectPath}`;
    }
  }, []);
};

export { SsoLogin };
